import Vue from 'vue'
import { Line, Pie, Bar } from 'vue-chartjs'

const charts = [
  {
    tag: 'line',
    component: Line
  },
  {
    tag: 'pie',
    component: Pie
  },
  {
    tag: 'bar',
    component: Bar
  }
]

for (let chart of charts) {
  Vue.component(chart.tag + '-chart', {
    extends: chart.component,
    props: ['data', 'color', 'label', 'labels'],
    data () {
      return {
        options: {
          labels: this.labels || [],
          datasets: [{
            label: this.label || 'Chart data',
            data: this.data || [],
            backgroundColor: this.color || '#ff733d'
          }]
        },
        settings: {
          responsive: true
        }
      }
    },
    mounted () {
      this.renderChart(this.options, this.settings)
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/_vendor/charts/index.js